<template >
  <div class="mainbody">
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">福利管理列表</span>
      <el-button type="primary" size="small" style="float: right" @click="addInfo()">新建</el-button>
    </div>
    <div class="aLine"></div>
    <div class="tableInfo">
      <el-table :data="data_list" @filter-change="filterChange" @sort-change="changeTableSort">
        <el-table-column prop="order" label="排序" min-width="1"></el-table-column>
        <el-table-column prop="title" label="福利名称" min-width="1"></el-table-column>
        <el-table-column label="福利图标" min-width="1">
          <template slot-scope="scope">
            <el-image style="cursor: pointer; width: 60px; height: 60px" :src="urlPath + scope.row.icon" :preview-src-list="[urlPath + scope.row.icon]" fit="scale-down">
              <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="resultStr" label="状态" min-width="1" :filters="optionsOpen" filter-placement="bottom-end" column-key="filterResult"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" min-width="1" sortable></el-table-column>
        <el-table-column prop="operating" label="操作" min-width="1" align="left">
          <template slot-scope="scope">
            <el-button class="operateText" size="mini" type="text" @click="editInfo(scope.row)">编辑</el-button>
            <el-button class="operateText" size="mini" type="text" @click="deleteInfo(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsOpen: Constant.options_open,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1
    }
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .welfareList({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize,
          order: this.order,
          screen_status: this.screen_status
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            this.optionsOpen.forEach(examin => {
              if (info.status == examin.value) {
                info.resultStr = examin.text
              }
            })
            info.create_time = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 排序
    changeTableSort(column) {
      this.order = StrUtils.getPropOrder(column)
      this.getList()
    },
    // 过滤
    filterChange(filters) {
      this.screen_status = StrUtils.getStr4List1(filters.filterResult)
      if (this.screen_status == '') this.screen_status = undefined
      this.getList()
    },
    // 新建
    addInfo() {
      this.$router.push({
        path: '/wxapp/welfare_add'
      })
    },
    // 编辑
    editInfo(row) {
      this.$router.push({
        path: '/wxapp/welfare_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除
    deleteInfo(row) {
      this.$confirm('是否删除此福利信息?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .delWelfare({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.operateText {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/welfare/welfareList.vue